import React from 'react'

import { CONVERSATION_TYPE } from '@lyrahealth-inc/shared-app-logic/src/models/messages/Messages'
import { ChatSideBarSelection } from '@lyrahealth-inc/ui-core-crossplatform/src/organisms/chatRightSideBar/ChatRightSideBar'

import MessengerClientDetailsSideBar from './items/MessengerClientDetailsSideBar'
import MessengerDocumentLibrarySideBar from './items/MessengerDocumentLibrarySideBar'
import MessengerSmartSuggestionsSideBar from './items/MessengerSmartSuggestionsSideBar'
import MessengerSummariesSideBar from './items/MessengerSummariesSideBar'
import MessengerTemplatesSideBar from './items/MessengerTemplatesSideBar'
import { useSelectedClientData } from '../../../clients/clientDetails/data/hooks/useSelectedClientData'
import { InsertMessageOptions } from '../../BaseChat'
import MessengerWellnessLibrarySideBar from './items/MessengerWellnessLibrarySideBar'
import { Template } from '../../../documents/data/templatesApi'

type MessengerSideBarContentProps = {
  selectedItem: ChatSideBarSelection
  conversationType?: CONVERSATION_TYPE
  insertMessage: (message: string, opts?: InsertMessageOptions) => void
  insertDirectBookingLink: () => void
  insertEssentialsArticleChip: () => void
  onOpenAssignment: (assignmentId: string) => void
  onOpenNotes: (noteId: string) => void
  onAttachDocument: (template: Template) => void
}

const MessengerSideBarContent: React.FC<MessengerSideBarContentProps> = ({
  selectedItem,
  conversationType,
  insertMessage,
  insertDirectBookingLink,
  insertEssentialsArticleChip,
  onOpenAssignment,
  onOpenNotes,
  onAttachDocument,
}) => {
  const { data: selectedClientDetails } = useSelectedClientData()
  const clientFirstName = selectedClientDetails?.preferred_first_name || selectedClientDetails?.first_name

  switch (selectedItem) {
    case ChatSideBarSelection.CLIENT_DETAILS:
      return <MessengerClientDetailsSideBar />
    case ChatSideBarSelection.TEMPLATES:
      return (
        <MessengerTemplatesSideBar
          insertMessage={insertMessage}
          insertDirectBookingLink={insertDirectBookingLink}
          conversationType={conversationType}
        />
      )
    case ChatSideBarSelection.SMART_SUGGESTIONS:
      return (
        <MessengerSmartSuggestionsSideBar
          insertMessage={insertMessage}
          onOpenAssignment={onOpenAssignment}
          onOpenNotes={onOpenNotes}
          conversationType={conversationType}
        />
      )
    case ChatSideBarSelection.SUMMARIES:
      return <MessengerSummariesSideBar clientName={clientFirstName} conversationType={conversationType} />
    case ChatSideBarSelection.WELLNESS_LIBRARY_ESSENTIALS:
      return (
        <MessengerWellnessLibrarySideBar
          insertEssentialsArticleChip={insertEssentialsArticleChip}
          conversationType={conversationType}
        />
      )
    case ChatSideBarSelection.DOCUMENT_LIBRARY:
      return <MessengerDocumentLibrarySideBar onAttachDocument={onAttachDocument} />
    default:
      return null
  }
}

export default MessengerSideBarContent
